import SessionStore from 'library/ts/utilities/SessionStore';
import { ParentEnvelope } from 'tag/ts/smart_tag/model/parent/envelope/ParentEnvelope';
import { AbstractTagClass } from 'tag/ts/tag/abstract/AbstractTagClass';
import { FreewheelDaiApiRequestFactory } from 'tag/ts/tag/ads/freewheel/factories/FreewheelDaiApiRequestFactory';
import { FreewheelDaiSdkRequestFactory } from 'tag/ts/tag/ads/freewheel/factories/FreewheelDaiSdkRequestFactory';
import { FreewheelDaiSsbRequestFactory } from 'tag/ts/tag/ads/freewheel/factories/FreewheelDaiSsbRequestFactory';
import { FreewheelImaRequestFactory } from 'tag/ts/tag/ads/freewheel/factories/FreewheelImaRequestFactory';
import { AdSetupDefinition } from 'tag/ts/tag/model/type/ads/AdSetupDefinition';
import { DefaultAviaConstants } from 'tag/ts/tag/player/adapters/avia/constants/DefaultAviaConstants';
export class AbstractResourceConfigBuilder extends AbstractTagClass {
    assetPlaybackUtil;
    constructor(argument = {
        name: 'AbstractResourceConfigBuilder',
        tag: undefined
    }) {
        super({
            ...argument
        });
    }
    clean = () => {
        return new Promise((resolve, reject) => {
            this.assetPlaybackUtil.clean()
                .then(() => {
                this.assetPlaybackUtil = null;
                resolve({
                    msg: 'clean successful',
                    success: true
                });
            })
                .catch((error) => {
                this.logger.warn('clean', 'Error:', error);
                reject({
                    msg: 'clean failed',
                    success: false,
                    error: error
                });
            });
        });
    };
    setStartBitrate(resource, bitrate = DefaultAviaConstants.getInstance().startBitrate) {
        return new Promise((resolve, reject) => {
            if (this.utils.Type.isEmpty(resource) ||
                !this.utils.Type.isNumber(bitrate)) {
                this?.logger?.warn('setStartBitrate', 'missing/invalid arguments... resolving resource unmodified', 'resource:', resource, 'bitrate:', bitrate);
                resolve(resource);
                return;
            }
            resource.playback.abr.startBitrate = bitrate;
            this?.logger?.log('setStartBitrate', 'set resource.playback.abr.startBitrate:', resource.playback.abr.startBitrate);
            resolve(resource);
        });
    }
    setOverrides(resource, overrides = DefaultAviaConstants.getInstance().overrides) {
        return new Promise((resolve, reject) => {
            if (this.utils.Type.isEmpty(resource) ||
                this.utils.Type.isEmpty(overrides) ||
                !this.utils.Type.isObject(overrides)) {
                this?.logger?.warn('setOverrides', 'missing/invalid arguments... returning resource unmodified', 'resource:', resource, 'overrides:', overrides);
                return resource;
            }
            resource.overrides = overrides;
            this?.logger?.log('setOverride', 'set resource.overrides:', resource.overrides);
            resolve(resource);
        });
    }
    setDrm(resource, drm = this.params?.CONTENT?.drm) {
        if (this.utils.Type.isEmpty(resource) ||
            this.utils.Type.isEmpty(drm) ||
            !this.utils.Type.isObject(drm)) {
            this?.logger?.warn('setDrm', 'missing/invalid arguments... returning resource unmodified', 'resource:', resource, 'drm:', drm);
            return resource;
        }
        resource.location.drm = this.utils.DeepMerge.deepmerge(resource.location.drm, drm);
        this?.logger?.log('setDrm', 'deep merged drm into resource.location.drm...', 'drm:', drm, 'resource.location.drm:', resource.location.drm);
        return resource;
    }
    setMediaUrl(resource, mediaUrl) {
        if (this.utils.Type.isEmpty(resource) ||
            this.utils.Type.isEmpty(mediaUrl) ||
            !this.utils.Type.isString(mediaUrl)) {
            this?.logger?.warn('setMediaUrl', 'missing/invalid arguments... returning resource unmodified', 'resource:', resource, 'mediaUrl:', mediaUrl);
            return resource;
        }
        resource.location.mediaUrl = mediaUrl;
        this?.logger?.log('setMediaUrl', 'set resource.location.mediaUrl:', resource.location.mediaUrl);
        return resource;
    }
    setStartTime(resource, startTime = this?.params?.CONTENT?.globalResumeTime) {
        if (this.utils.Type.isEmpty(resource) ||
            this.utils.Type.isEmpty(startTime) ||
            !this.utils.Type.isNumber(startTime) ||
            startTime < 0) {
            this?.logger?.warn('setStartTime', 'missing/invalid arguments... returning resource unmodified', 'resource:', resource, 'startTime:', startTime);
            return resource;
        }
        resource.playback.startTime = startTime;
        this?.logger?.log('setStartTime', 'set resource.playback.startTime:', resource.playback.startTime);
        return resource;
    }
    setThumbnailTrackUrl(resource, url) {
        if (this.utils.Type.isEmpty(resource) ||
            this.utils.Type.isEmpty(url) ||
            !this.utils.Type.isString(url)) {
            this?.logger?.warn('setThumbnailTrackUrl', 'missing/invalid arguments... returning resource unmodified', 'resource:', resource, 'url:', url);
            return resource;
        }
        resource.location.thumbnailTrackUrl = url;
        this?.logger?.log('setThumbnailTrackUrl', 'set resource.location.thumbnailTrackUrl:', resource.location.thumbnailTrackUrl);
        return resource;
    }
    initCsai(resource) {
        if (!this.utils.Type.isEmpty(resource?.ad?.csai)) {
            this?.logger?.warn('initCsai', 'resource.ad.csai is not empty... overriding:', JSON.stringify(resource.ad.csai));
        }
        resource.ad.csai = {};
        this?.logger?.log('initCsai', 'initialized resource.ad.csai = {}', 'resource:', resource);
        return resource;
    }
    removeCsai(resource) {
        if (this.utils.Type.isEmpty(resource)) {
            this?.logger?.warn('removeCsai', 'missing/invalid arguments... returning resource unmodified', 'resource:', resource);
            return resource;
        }
        if (!this.utils.Type.isEmpty(resource?.ad?.csai)) {
            this?.logger?.warn('removeCsai', 'resource.ad.csai is not empty... removing:', JSON.stringify(resource.ad.csai));
        }
        resource.ad.csai = null;
        this?.logger?.log('removeCsai', 'set resource.ad.csai = null');
        return resource;
    }
    setCsaiParameter(resource, key, value) {
        if (this.utils.Type.isEmpty(resource) ||
            this.utils.Type.isEmpty(key) ||
            !this.utils.Type.isString(key)) {
            this?.logger?.warn('setCsaiParameter', 'missing/invalid arguments... returning resource unmodified', 'resource:', resource, 'key:', key, 'value:', value);
            return resource;
        }
        if (this.utils.Type.isEmpty(resource?.ad?.csai)) {
            resource = this.initCsai(resource);
        }
        resource.ad.csai[key] = value;
        this?.logger?.log('setCsaiParameter', `set resource.ad.csai.${key}:`, value);
        return resource;
    }
    initSsai(resource) {
        if (!this.utils.Type.isEmpty(resource?.ad?.ssai)) {
            this?.logger?.warn('initSsai', 'resource.ad.ssai is not empty... overriding:', JSON.stringify(resource.ad.ssai));
        }
        resource.ad.ssai = {};
        this?.logger?.log('initSsai', 'initialized resource.ad.ssai = {}', 'resource:', resource);
        return resource;
    }
    removeSsai(resource) {
        if (this.utils.Type.isEmpty(resource)) {
            this?.logger?.warn('removeSsai', 'missing/invalid arguments... returning resource unmodified', 'resource:', resource);
            return resource;
        }
        if (!this.utils.Type.isEmpty(resource?.ad?.ssai)) {
            this?.logger?.warn('removeSsai', 'resource.ad.ssai is not empty... removing:', JSON.stringify(resource.ad.ssai));
        }
        resource.ad.ssai = null;
        this?.logger?.log('removeSsai', 'set resource.ad.ssai = null');
        return resource;
    }
    setSsaiParameter(resource, key, value) {
        if (this.utils.Type.isEmpty(resource) ||
            this.utils.Type.isEmpty(key) ||
            !this.utils.Type.isString(key)) {
            this?.logger?.warn('setSsaiParameter', 'missing/invalid arguments... returning resource unmodified', 'resource:', resource, 'key:', key, 'value:', value);
            return resource;
        }
        if (this.utils.Type.isEmpty(resource?.ad?.ssai)) {
            resource = this.initSsai(resource);
        }
        resource.ad.ssai[key] = value;
        this?.logger?.log('setSsaiParameter', `set resource.ad.ssai.${key}:`, value);
        return resource;
    }
    initSsaiAdParameter(resource) {
        if (this.utils.Type.isEmpty(resource)) {
            this?.logger?.warn('initSsaiAdParameter', 'missing/invalid arguments... returning resource unmodified', 'resource:', resource);
            return resource;
        }
        if (this.utils.Type.isEmpty(resource?.ad?.ssai)) {
            resource = this.initSsai(resource);
        }
        if (!this.utils.Type.isEmpty(resource.ad.ssai.adParameters)) {
            this?.logger?.warn('initSsaiAdParameter', 'resource.ad.ssai.adParameters is not empty... overriding:', JSON.stringify(resource.ad.ssai.adParameters));
        }
        resource.ad.ssai.adParameters = {};
        this?.logger?.log('initSsaiAdParameter', 'initialized resource.ad.ssai.adParameters={}', 'resource:', resource);
        return resource;
    }
    setSsaiAdParameter(resource, key, value) {
        if (this.utils.Type.isEmpty(resource) ||
            this.utils.Type.isEmpty(key) ||
            !this.utils.Type.isString(key)) {
            this?.logger?.warn('setSsaiAdParameter', 'missing/invalid arguments... returning resource unmodified', 'resource:', resource, 'key:', key, 'value:', value);
            return resource;
        }
        if (this.utils.Type.isEmpty(resource?.ad?.ssai?.adParameters)) {
            resource = this.initSsaiAdParameter(resource);
        }
        resource.ad.ssai.adParameters[key] = value;
        this?.logger?.log('setSsaiParameter', `set resource.ad.ssai.adParameters.${key}:`, value);
        return resource;
    }
    deepMergeResourceFromSmartTagParams(resourceParam) {
        if (this.utils.Type.isEmpty(this.params?.CONTENT?.resource) ||
            !this.utils.Type.isObject(this.params?.CONTENT?.resource)) {
            this?.logger?.log('deepMergeResourceFromSmartTagParams', 'params.CONTENT.resource is unset... returning resource unmodified');
            return resourceParam;
        }
        this?.logger?.log('deepMergeResourceFromSmartTagParams', 'params.CONTENT.resource is set:', this.params.CONTENT.resource);
        if (!this.utils.Type.isEmpty(this.params?.CONTENT?.resource?.location) &&
            this.utils.Type.isObject(this.params?.CONTENT?.resource?.location) &&
            this.utils.Type.isEmpty(this?.params?.CONTENT?.resource?.location?.mediaUrl)) {
            delete this.params.CONTENT.resource.location.mediaUrl;
            this?.logger?.log('deepMergeResourceFromSmartTagParams', 'removed params.CONTENT.resource.location.mediaUrl');
        }
        const resourceMerged = this.utils.DeepMerge.deepmerge(resourceParam, this.params?.CONTENT?.resource);
        this?.logger?.log('deepMergeResourceFromSmartTagParams', 'deep merged params.CONTENT.resource into resource');
        if (this.runtimeVO?.debug?.on === true) {
            const smartTagResource = this.utils.Object.cloneDeep(resourceParam);
            const initialComparison = this.utils.Compare.compare(smartTagResource, this.params?.CONTENT?.resource);
            const mergedComparison = this.utils.Compare.compare(smartTagResource, resourceMerged);
            this?.logger?.log('\n---', '\n smartTagResource resource', smartTagResource, '\n params-supplied resource', this.params?.CONTENT?.resource, '\n merged resource', resourceMerged, '\n initial comparison (Smart Tag generated vs incoming params)', initialComparison, '\n merged comparison (Smart Tag generated vs merged resource)', mergedComparison, '\n---');
        }
        return resourceMerged || resourceParam;
    }
    sanitizeResource(resource) {
        const adSetupInfo = this.tag?.model?.adUtilities?.adSetupInfo();
        if (this.utils.Type.isObject(resource?.ad) &&
            !this.utils.Type.isEmpty(resource?.ad)) {
            delete resource.ad['dai'];
            delete resource.ad['ima'];
            this?.logger?.log('sanitizeResource', 'deleted resource.ad.dai, resource.ad.ima');
        }
        switch (adSetupInfo?.setup?.definition) {
            case AdSetupDefinition.DAI_SSB:
                resource = this.removeCsai(resource);
                resource = this.removeSsai(resource);
                this?.logger?.log('sanitizeResource', 'adSetupInfo.setup.definition = AdSetupDefinition.DAI_SSB... removed unneeded resource.ad.csai, resource.ad.ssai');
                break;
        }
        return resource;
    }
    testOverrides(resource) {
        switch (this.runtimeVO.parentEnvelope) {
            case ParentEnvelope.TEST_WWW_PPLUS:
                if (this.apiMetadata.contentId === 'RNwC4Zv1QWvw8HquUke7sRpdycsukVhf') {
                    resource.playback.enableAdvancedCodecs = true;
                }
                break;
        }
        return resource;
    }
    setViewabilityTracking(resource, trackingObj) {
        if (this.utils.Type.isEmpty(resource) ||
            this.utils.Type.isEmpty(trackingObj) ||
            !this.utils.Type.isObject(trackingObj)) {
            this?.logger?.warn('setViewabilityTracking', 'missing/invalid arguments... returning resource unmodified', 'resource:', resource, 'trackingObj:', trackingObj);
            return resource;
        }
        if (this.utils.Type.isEmpty(resource?.ad)) {
            resource.ad = {};
            this?.logger?.log('setViewabilityTracking', 'initialized resource.ad={}');
        }
        resource.ad.viewabilityTracking = trackingObj;
        this?.logger?.log('setViewabilityTracking', 'set resource.ad.viewabilityTracking:', resource.ad.viewabilityTracking);
        return resource;
    }
    configureNflLts(resource) {
        if (!this?.params?.CONTENT?.channelInfo?.isLTSEnabled || !this?.params?.CONTENT?.channelInfo?.isOptinRequired) {
            this?.logger?.log('configureNflLts', 'NFL LTS configuration not required');
            return resource;
        }
        const sessionStore = SessionStore.getInstance();
        const nflLTSOptIn = this?.params?.USER?.nflLTS?.optIn;
        const nflLTSOptInTime = this?.params?.USER?.nflLTS?.optInTime;
        const episode = this?.params?.CONTENT?.channelInfo?.currentListing?.[0] || sessionStore?.get('episode');
        const gameStartTimestamp = episode?.gameStartTimestamp;
        const ctaText = sessionStore?.get('sfbOptionTriggerLabel') || '';
        if (this.utils.Type.isObject(resource?.metadata)) {
            resource.metadata.ltsOptInStatus ??= `${nflLTSOptIn || false}`;
            resource.metadata.currentListingTitle ??= episode?.title || '';
            resource.metadata.ctaText ??= ctaText || '';
        }
        if (!this.utils.Type.isNumber(gameStartTimestamp)) {
            this?.logger?.warn('configureNflLts', 'gameStartTimestamp is missing/invalid. channelInfo:', this?.params?.CONTENT?.channelInfo);
            return resource;
        }
        const optedInBeforeGameStart = nflLTSOptIn && nflLTSOptInTime < gameStartTimestamp;
        if (optedInBeforeGameStart) {
            this?.logger?.log('configureNflLts', 'user opted in before game start... allowing scrubbing to entire buffer');
            return resource;
        }
        if (!this.utils.Type.isObject(resource?.playback)) {
            this?.logger?.warn('configureNflLts', 'user opted in after game start... but the playback configuration object is missing/invalid:, playback', resource?.playback);
            return resource;
        }
        resource.playback.lts ??= {};
        resource.playback.lts.restrictionTimestamp = -1;
        resource.playback.lts.threshold = 60;
        this?.logger?.log('configureNflLts', 'user opted in after game start... restricted scrubbing to stream join time');
        return resource;
    }
    setApiKey(resource, apiKey) {
        return this.setSsaiParameter(resource, 'apiKey', apiKey);
    }
    setAssetKey(resource, assetKey) {
        return this.setSsaiParameter(resource, 'assetKey', assetKey);
    }
    setIsLive(resource, isLive) {
        return this.setSsaiParameter(resource, 'isLive', isLive);
    }
    setAuthToken(resource, authToken) {
        return this.setSsaiParameter(resource, 'authToken', authToken);
    }
    setContentSourceId(resource, contentSourceId) {
        return this.setSsaiParameter(resource, 'contentSourceId', contentSourceId);
    }
    setVideoId(resource, videoId) {
        return this.setSsaiParameter(resource, 'videoId', videoId);
    }
    setFormat(resource, format) {
        return this.setSsaiParameter(resource, 'format', format);
    }
    setFilterOutPremiumAudioCodecs(resource, canFilter) {
        return this.setSsaiParameter(resource, 'filterOutPremiumAudioCodecs', canFilter);
    }
    setUseApi(resource, useApi) {
        return this.setSsaiParameter(resource, 'useApi', useApi);
    }
    setEnableNonce(resource, enableNonce) {
        return this.setSsaiParameter(resource, 'enableNonce', !!enableNonce ? 'true' : 'false');
    }
    setCustParams(resource, custParams) {
        return this.setSsaiAdParameter(resource, 'cust_params', custParams);
    }
    setMillstoneDAIParams(resource) {
        if (this.utils.Type.isEmpty(this?.params?.CONTENT?.millstone?.daiParams) ||
            !this.utils.Type.isObject(this?.params?.CONTENT?.millstone?.daiParams)) {
            this?.logger?.log('setMillstoneDAIParams', 'params.CONTENT.millstone.daiParams is unset/invalid... returning resource unmodified');
            return resource;
        }
        else {
            this?.logger?.log('setMillstoneDAIParams', 'params.CONTENT.millstone.daiParams is set... setting in resource as SSAI ad parameter', 'daiParams:', this.params.CONTENT.millstone.daiParams);
            Object.keys((this.params.CONTENT.millstone.daiParams))
                .filter((key) => {
                if (this.utils.Type.isEmpty(this.params.CONTENT.millstone.daiParams[key])) {
                    this?.logger?.warn('setMillstoneDAIParams', 'filtering out param with unset value...', '\tkey:', key, '\tvalue:', this.params.CONTENT.millstone.daiParams[key]);
                    return false;
                }
                return true;
            })
                .forEach((key) => {
                resource = this.setSsaiAdParameter(resource, key, this.params.CONTENT.millstone.daiParams[key]);
            });
            return resource;
        }
    }
    createFreewheelRequest(adSetupInfo) {
        switch (adSetupInfo?.setup?.definition) {
            case AdSetupDefinition.DAI_SDK:
                return new FreewheelDaiSdkRequestFactory({ tag: this.tag }).createRequest();
            case AdSetupDefinition.DAI_SSB:
                return new FreewheelDaiSsbRequestFactory({ tag: this.tag }).createRequest();
            case AdSetupDefinition.DAI_API:
                return new FreewheelDaiApiRequestFactory({ tag: this.tag }).createRequest();
            case AdSetupDefinition.IMA:
            case AdSetupDefinition.LINEAR_AD_TRACKING:
                return new FreewheelImaRequestFactory({ tag: this.tag }).createRequest();
            case AdSetupDefinition.NONE:
                return undefined;
            default:
                this.logger.warn('createRequest', 'ad setup definition not recognized, cannot init FreewheelRequest', 'adSetupInfo:', adSetupInfo);
                return undefined;
        }
    }
}
